var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "bg-white" }, [
        !_vm.editVisibility
          ? _c(
              "div",
              {
                ref: "property-header-" + _vm.propertyIndex,
                staticClass: "card card-separator",
                staticStyle: {
                  "background-color": "var(--primary-clear) !important",
                },
                attrs: { id: "property-header\n      -" + _vm.propertyIndex },
              },
              [
                _c("resize-sensor", {
                  attrs: { debounce: 50 },
                  on: {
                    resized: function (el) {
                      return _vm.handleResize(
                        "property-header-" + _vm.propertyIndex
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-header bg-transparent bb-0 px-5 resize-wrapper h-100",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "row align-items-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-auto col-12 d-flex justify-content-between align-items-center",
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("application-card-header", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.ordinalIndex(
                                                      _vm.arrayIndex
                                                    )
                                                  ) +
                                                  "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application-form.propertyOwnedBy"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _vm.applicantFullNameWithSalutation
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                     -\n                    " +
                                                      _vm._s(
                                                        _vm._f("truncateText")(
                                                          _vm.applicantFullNameWithSalutation,
                                                          20
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "sub-title",
                                        fn: function () {
                                          return [
                                            _vm.address && _vm.address.line1
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.address.line1
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ])
                                              : _c("span", [_vm._v("   ")]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1450483602
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("inline-prompt", {
                                  ref: "prompt",
                                  staticClass:
                                    "d-inline-block bold text-gray ml-2",
                                  attrs: {
                                    "action-type": "delete",
                                    "confirmation-text": _vm.$t(
                                      "application.messages.allDataWillBeLost"
                                    ),
                                  },
                                  on: {
                                    accept: function ($event) {
                                      _vm.handleRemove(
                                        _vm.property.propertyIndex,
                                        _vm.getApplicantKey(
                                          _vm.property["applicantIndex"]
                                        ) + "]['other-properties']"
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "field",
                          {
                            staticClass: "text-lg-right mt-lg-0 mt-2",
                            attrs: {
                              "edit-visibility": _vm.editVisibility,
                              "hide-eye": true,
                              "visibility-paths": [
                                _vm.visibilityPaths.includeInTds,
                              ],
                              "size-class": "col",
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          },
                          [
                            _c("checkbox-section", {
                              attrs: {
                                name:
                                  "include-in-tds-" +
                                  _vm.applicantIndex +
                                  "-" +
                                  _vm.propertyIndex,
                                "label-from-name": "",
                                label: _vm.$t(
                                  "application-form.include-tds-calculation"
                                ),
                                "container-class": "mb-0",
                                "multi-line": false,
                              },
                              model: {
                                value: _vm.includeInTds,
                                callback: function ($$v) {
                                  _vm.includeInTds = $$v
                                },
                                expression: "includeInTds",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "property-details-" + _vm.propertyIndex,
          staticClass: "card single-card",
          attrs: { id: "property-details-" + _vm.propertyIndex },
        },
        [
          _c("resize-sensor", {
            attrs: { debounce: 50 },
            on: {
              resized: function (el) {
                return _vm.handleResize("property-details-" + _vm.propertyIndex)
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "resize-wrapper h-auto" }, [
            _c(
              "div",
              {
                staticClass: "card-header px-5",
                attrs: {
                  id: _vm._f("hashId")(
                    _vm.applicantKey +
                      "[other-properties][" +
                      _vm.propertyIndex +
                      "]"
                  ),
                },
              },
              [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-11" },
                    [
                      _c("application-card-header", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-form.property-details"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "sub-title",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.ordinalIndex(_vm.arrayIndex)
                                        ) +
                                        "\n                  " +
                                        _vm._s(
                                          _vm.$t("application-form.property")
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.applicantFullNameWithSalutation
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                   - " +
                                            _vm._s(
                                              _vm.applicantFullNameWithSalutation
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            _vm.address && _vm.address.line1
                              ? {
                                  key: "extra",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.address.line1) +
                                          "\n              "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.editVisibility
                    ? _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("multiple-visibility-button", {
                            attrs: {
                              "visibility-paths":
                                _vm.PagesVisibilityMap[
                                  "other-property-property-details"
                                ],
                              "applicant-type": _vm.applicantType,
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body px-5" },
              [
                _c(
                  "div",
                  { staticClass: "row align-items-end" },
                  [
                    _c("text-section", {
                      staticClass: "d-none",
                      attrs: {
                        name: "order",
                        value: _vm.property.order,
                        label: _vm.$t("global.words.sort"),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "hide-eye": true,
                          "size-class": "col-md-6 col-12",
                          title: _vm.$t(
                            "application-form.this-property-is-associated-with"
                          ),
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c("select-section", {
                          attrs: {
                            value: _vm.applicantIndex,
                            name: "associated-with",
                            options: _vm.applicantSelectOptions,
                            tabindex: _vm.tabIndex(800),
                          },
                          on: { change: _vm.changePropertyOwnership },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "field",
                      {
                        attrs: {
                          "edit-visibility": _vm.editVisibility,
                          "visibility-paths": _vm.occupancyPaths,
                          "size-class": "col-md-6 col-12",
                          title: _vm.$t(
                            "application-form.property-occupancy-type"
                          ),
                        },
                        on: { "toggle-visibility": _vm.handleVisibility },
                      },
                      [
                        _c("select-section", {
                          attrs: {
                            name: "occupancy",
                            tabindex: _vm.tabIndex(800),
                            options: _vm.occupancyActionTypeOptions,
                          },
                          model: {
                            value: _vm.occupancy,
                            callback: function ($$v) {
                              _vm.occupancy = $$v
                            },
                            expression: "occupancy",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-fade" } }, [
                  _vm.property.applicantIndex != null
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "row align-items-end" },
                          [
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.address,
                                  ],
                                  title: _vm.editVisibility
                                    ? _vm.$tc("application-form.address", 1)
                                    : "",
                                  "size-class": "col-12",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("address-section", {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "show-labels": !_vm.editVisibility,
                                    title: _vm.editVisibility
                                      ? ""
                                      : _vm.$tc("application-form.address", 1),
                                    path: _vm.visibilityPaths.address,
                                    map: false,
                                    coapp: false,
                                    removable: false,
                                    time: false,
                                    replicate: _vm.arrayIndex === 0,
                                    index: 0,
                                    "replicate-text": _vm.$t(
                                      "application-form.copy-current-address"
                                    ),
                                    "success-replicated-text": _vm.$t(
                                      "application-form.copied-current-address"
                                    ),
                                    tabindex: _vm.tabIndex(800),
                                    "max-length": "",
                                  },
                                  on: { replicate: _vm.handleReplicateAddress },
                                  model: {
                                    value: _vm.address,
                                    callback: function ($$v) {
                                      _vm.address = $$v
                                    },
                                    expression: "address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row align-items-end mt-4" },
                          [
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.purchasePrice,
                                  ],
                                  "size-class": "col-md-4 col-12",
                                  title: _vm.$t(
                                    "application-form.original-value"
                                  ),
                                  "container-class": "dollar-prepend",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "purchase-price",
                                    placeholder: "0",
                                    "class-name": "dollar",
                                    tabindex: _vm.tabIndex(800),
                                    label: _vm.$t(
                                      "application-form.original-value"
                                    ),
                                  },
                                  model: {
                                    value: _vm.purchasePrice,
                                    callback: function ($$v) {
                                      _vm.purchasePrice = $$v
                                    },
                                    expression: "purchasePrice",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.estimatedValue,
                                  ],
                                  "size-class": "col-md-4 col-12",
                                  title: _vm.$t(
                                    "application-form.property-value"
                                  ),
                                  "container-class": "dollar-prepend",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "estimated-value",
                                    placeholder: "0",
                                    "class-name": "dollar",
                                    label: _vm.$t(
                                      "application-form.property-value"
                                    ),
                                    tabindex: _vm.tabIndex(800),
                                  },
                                  model: {
                                    value: _vm.estimatedValue,
                                    callback: function ($$v) {
                                      _vm.estimatedValue = $$v
                                    },
                                    expression: "estimatedValue",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "field",
                              {
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.purchaseDate,
                                  ],
                                  "size-class": "col-md-4 col-12",
                                  title: _vm.$t(
                                    "application-form.purchase-date"
                                  ),
                                  "container-class": "",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("date-section", {
                                  attrs: {
                                    name: "purchase-date",
                                    placeholder: "YYYY-MM-DD",
                                    "class-name": "date-format",
                                    tabindex: _vm.tabIndex(800),
                                    label: _vm.$t(
                                      "application-form.purchase-date"
                                    ),
                                  },
                                  on: { change: _vm.handleSave },
                                  model: {
                                    value: _vm.purchaseDate,
                                    callback: function ($$v) {
                                      _vm.purchaseDate = $$v
                                    },
                                    expression: "purchaseDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.property.applicantIndex != null
          ? _c("div", { staticClass: "w-100" }, [
              _c(
                "div",
                {
                  ref: "property-taxes-" + _vm.propertyIndex,
                  staticClass: "card single-card",
                  attrs: { id: "property-taxes-" + _vm.propertyIndex },
                },
                [
                  _c("resize-sensor", {
                    attrs: { debounce: 50 },
                    on: {
                      resized: function (el) {
                        return _vm.handleResize(
                          "property-taxes-" + _vm.propertyIndex
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "resize-wrapper h-auto" }, [
                    _c("div", { staticClass: "card-header px-5" }, [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c(
                          "div",
                          { staticClass: "col-11" },
                          [
                            _c("application-card-header", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-form.property-taxes"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "sub-title",
                                    fn: function () {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.ordinalIndex(_vm.arrayIndex)
                                              ) +
                                              "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-form.property"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.applicantFullNameWithSalutation
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                       - " +
                                                  _vm._s(
                                                    _vm.applicantFullNameWithSalutation
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  _vm.address && _vm.address.line1
                                    ? {
                                        key: "extra",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.address.line1) +
                                                "\n                  "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      }
                                    : null,
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.editVisibility
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("multiple-visibility-button", {
                                  attrs: {
                                    "visibility-paths":
                                      _vm.PagesVisibilityMap[
                                        "other-property-property-taxes"
                                      ],
                                    "applicant-type": _vm.applicantType,
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body px-5" }, [
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.propertyTaxes,
                                ],
                                "size-class": "col-md-4 col-12",
                                title: _vm.$t(
                                  "application-form.annual-property-taxes"
                                ),
                                "container-class": "dollar-prepend",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "property-taxes",
                                  placeholder: "0",
                                  "class-name": "dollar",
                                  label: _vm.$t(
                                    "application-form.annual-property-taxes"
                                  ),
                                  tabindex: _vm.tabIndex(900),
                                },
                                model: {
                                  value: _vm.propertyTaxes,
                                  callback: function ($$v) {
                                    _vm.propertyTaxes = $$v
                                  },
                                  expression: "propertyTaxes",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.maintenanceFees,
                                ],
                                "size-class": "col-md-4 col-12",
                                title: _vm.$t(
                                  "application-form.maintenance-fees-monthly"
                                ),
                                "container-class": "dollar-prepend",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "maintenance-fees",
                                  placeholder: "0",
                                  "class-name": "dollar",
                                  label: _vm.$t(
                                    "application-form.maintenance-fees-monthly"
                                  ),
                                  tabindex: _vm.tabIndex(900),
                                },
                                model: {
                                  value: _vm.maintenanceFees,
                                  callback: function ($$v) {
                                    _vm.maintenanceFees = $$v
                                  },
                                  expression: "maintenanceFees",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.percOfTotalMaintFees,
                                ],
                                "size-class": "col-md-4 col-12",
                                title: _vm.$t(
                                  "application-form.condo-fee-allocation-percentage"
                                ),
                                "container-class": "perc-append",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "perc-of-total-maint-fees",
                                  placeholder: "0",
                                  "class-name": "percentage",
                                  label: _vm.$t(
                                    "application-form.condo-fee-allocation-percentage"
                                  ),
                                  tabindex: _vm.tabIndex(900),
                                },
                                model: {
                                  value: _vm.percOfTotalMaintFees,
                                  callback: function ($$v) {
                                    _vm.percOfTotalMaintFees = $$v
                                  },
                                  expression: "percOfTotalMaintFees",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row align-items-start" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.feesIncludeHeat,
                                ],
                                "size-class": "col-md-4 col-12",
                                title: _vm.editVisibility
                                  ? _vm.$t("application-form.is-heat-included")
                                  : "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("checkbox-section", {
                                attrs: {
                                  label: _vm.$t(
                                    "application-form.is-heat-included"
                                  ),
                                  name:
                                    "fees-include-heat-" +
                                    _vm.applicantIndex +
                                    "-" +
                                    _vm.propertyIndex,
                                  "label-from-name": "",
                                  tabindex: _vm.tabIndex(900),
                                },
                                model: {
                                  value: _vm.feesIncludeHeat,
                                  callback: function ($$v) {
                                    _vm.feesIncludeHeat = $$v
                                  },
                                  expression: "feesIncludeHeat",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "slide-fade" } },
                            [
                              _vm.editVisibility ||
                              _vm.visibilityToggle(
                                _vm.currentApplication,
                                _vm._visibilityDataContext,
                                _vm.getApplicantKey(
                                  _vm.property["applicantIndex"]
                                ) +
                                  "[other-properties][" +
                                  _vm.propertyIndex +
                                  "]]['property-costs']['fees-include-heat']",
                                _vm.binaryFalseShowsOptions,
                                "heating"
                              )
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.heating,
                                        ],
                                        "size-class": "col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.heat-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "heating",
                                          placeholder: "0",
                                          "class-name": "fe-num-field dollar",
                                          label: _vm.$t(
                                            "application-form.heat-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(900),
                                        },
                                        model: {
                                          value: _vm.heating,
                                          callback: function ($$v) {
                                            _vm.heating = $$v
                                          },
                                          expression: "heating",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "property-fees-" + _vm.propertyIndex,
                  staticClass: "card single-card",
                  attrs: { id: "property-fees-" + _vm.propertyIndex },
                },
                [
                  _c("resize-sensor", {
                    attrs: { debounce: 50, throttle: 300 },
                    on: {
                      resized: function (el) {
                        return _vm.handleResize(
                          "property-fees-" + _vm.propertyIndex
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "resize-wrapper h-auto" }, [
                    _c("div", { staticClass: "card-header px-5" }, [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c(
                          "div",
                          { staticClass: "col-11" },
                          [
                            _c("application-card-header", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-form.property-fees"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "sub-title",
                                    fn: function () {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.ordinalIndex(_vm.arrayIndex)
                                              ) +
                                              "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-form.property"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.applicantFullNameWithSalutation
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                       - " +
                                                  _vm._s(
                                                    _vm.applicantFullNameWithSalutation
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  _vm.address && _vm.address.line1
                                    ? {
                                        key: "extra",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.address.line1) +
                                                "\n                  "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      }
                                    : null,
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.editVisibility
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("multiple-visibility-button", {
                                  attrs: {
                                    "visibility-paths":
                                      _vm.PagesVisibilityMap[
                                        "other-property-property-fees"
                                      ],
                                    "applicant-type": _vm.applicantType,
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body px-5" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-12",
                            class: {
                              "col-lg-6": _vm.extraFeesInformationIsNeeded,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.editVisibility ||
                                    _vm.visibilityToggle(
                                      _vm.currentApplication,
                                      _vm._visibilityDataContext,
                                      _vm.getApplicantKey(
                                        _vm.property["applicantIndex"]
                                      ) +
                                        "[other-properties][" +
                                        _vm.propertyIndex +
                                        "]]['property-rental']['occupancy']",
                                      _vm.occupancyActionTypeOptions,
                                      "monthlyIncome"
                                    )
                                      ? _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .monthlyIncome,
                                              ],
                                              "size-class": "col-md-6 col-12",
                                              title: _vm.$t(
                                                "application-form.rental-monthly-income"
                                              ),
                                              "container-class":
                                                "dollar-prepend",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("text-section", {
                                              attrs: {
                                                name: "monthly-income",
                                                placeholder: "0",
                                                "class-name": "dollar",
                                                label: _vm.$t(
                                                  "application-form.rental-monthly-income"
                                                ),
                                                tabindex: _vm.tabIndex(1000),
                                              },
                                              model: {
                                                value: _vm.monthlyIncome,
                                                callback: function ($$v) {
                                                  _vm.monthlyIncome = $$v
                                                },
                                                expression: "monthlyIncome",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.editVisibility ||
                                    _vm.visibilityToggle(
                                      _vm.currentApplication,
                                      _vm._visibilityDataContext,
                                      _vm.getApplicantKey(
                                        _vm.property.applicantIndex
                                      ) +
                                        "[other-properties][" +
                                        _vm.propertyIndex +
                                        "]][property-rental][occupancy]",
                                      _vm.occupancyActionTypeOptions,
                                      "rentalIncomeOptions"
                                    )
                                      ? _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .rentalIncomeOptions,
                                                _vm.visibilityPaths
                                                  .rentalIncomeOptionsPercent,
                                              ],
                                              "size-class": "col-md-6 col-12",
                                              title: _vm.$t(
                                                "application-form.rental-income-options"
                                              ),
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("select-section", {
                                              attrs: {
                                                name: "rental-income-options",
                                                options:
                                                  _vm.rentalIncomeSelectOptions,
                                                tabindex: _vm.tabIndex(1000),
                                              },
                                              model: {
                                                value: _vm.rentalIncomeOptions,
                                                callback: function ($$v) {
                                                  _vm.rentalIncomeOptions = $$v
                                                },
                                                expression:
                                                  "rentalIncomeOptions",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "transition",
                                  { attrs: { name: "slide-fade" } },
                                  [
                                    _vm.editVisibility ||
                                    (_vm.visibilityToggle(
                                      _vm.currentApplication,
                                      _vm._visibilityDataContext,
                                      _vm.getApplicantKey(
                                        _vm.property.applicantIndex
                                      ) +
                                        "[other-properties][" +
                                        _vm.propertyIndex +
                                        "][property-rental][occupancy]",
                                      _vm.occupancyActionTypeOptions,
                                      "rentalIncomeOptionsPercent"
                                    ) &&
                                      _vm.visibilityToggle(
                                        _vm.currentApplication,
                                        _vm._visibilityDataContext,
                                        _vm.getApplicantKey(
                                          _vm.property.applicantIndex
                                        ) +
                                          "[other-properties][" +
                                          _vm.propertyIndex +
                                          "][property-rental][rental-income-options]",
                                        _vm.rentalIncomeSelectOptions,
                                        "rentalIncomeOptionsPercent"
                                      ))
                                      ? _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .rentalIncomeOptionsPercent,
                                              ],
                                              "depends-upon": [
                                                _vm.visibilityPaths
                                                  .rentalIncomeOptions,
                                              ],
                                              "size-class":
                                                "col-lg-6 offset-lg-6 col-12",
                                              title: _vm.$t(
                                                "application-form.rental-income-offset-percent"
                                              ),
                                              "container-class": "perc-append",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("text-section", {
                                              attrs: {
                                                name: "rental-income-options-percent",
                                                placeholder: "0",
                                                "class-name": "percentage",
                                                label: _vm.$t(
                                                  "application-form.rental-income-offset-percent"
                                                ),
                                                tabindex: _vm.tabIndex(1000),
                                              },
                                              model: {
                                                value:
                                                  _vm.rentalIncomeOptionsPercent,
                                                callback: function ($$v) {
                                                  _vm.rentalIncomeOptionsPercent =
                                                    $$v
                                                },
                                                expression:
                                                  "rentalIncomeOptionsPercent",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "hide-eye": true,
                                      "size-class": "col-6",
                                      "visibility-paths": [
                                        _vm.visibilityPaths.propertyEquity,
                                      ],
                                      title: _vm.$t(
                                        "application-form.proceeds-from-sales"
                                      ),
                                      "container-class": "dollar-prepend",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "property-equity",
                                        placeholder: "0",
                                        disabled: _vm.tiedDownpayment,
                                        "class-name": "dollar",
                                        label: _vm.$t(
                                          "application-form.proceeds-from-sales"
                                        ),
                                        tabindex: _vm.tabIndex(1000),
                                      },
                                      model: {
                                        value: _vm.propertyEquity,
                                        callback: function ($$v) {
                                          _vm.propertyEquity = $$v
                                        },
                                        expression: "propertyEquity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex align-items-center",
                                    class: _vm.extraFeesInformationIsNeeded
                                      ? "col-8"
                                      : "col-6",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-sm",
                                        attrs: {
                                          disabled:
                                            _vm.tiedDownpayment ||
                                            _vm.missingDescription ||
                                            _vm.isMissingValue,
                                          type: "button",
                                        },
                                        on: { click: _vm.addDownPayment },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-form.create-down-payment"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6 col-12" }, [
                          _c(
                            "div",
                            { staticClass: "row align-items-end" },
                            [
                              _vm.editVisibility || _vm.showHydroFeesInput
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.hydro,
                                        ],
                                        "size-class": "col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.hydro-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "hydro",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          label: _vm.$t(
                                            "application-form.hydro-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(1000),
                                        },
                                        model: {
                                          value: _vm.hydro,
                                          callback: function ($$v) {
                                            _vm.hydro = $$v
                                          },
                                          expression: "hydro",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.editVisibility || _vm.showOtherFeesInput
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.others,
                                        ],
                                        "size-class": "col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.other-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "others",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          label: _vm.$t(
                                            "application-form.other-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(1000),
                                        },
                                        model: {
                                          value: _vm.others,
                                          callback: function ($$v) {
                                            _vm.others = $$v
                                          },
                                          expression: "others",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.editVisibility || _vm.showManagementFeesInput
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.management,
                                        ],
                                        "size-class": "col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.management-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "management",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          label: _vm.$t(
                                            "application-form.management-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(1000),
                                        },
                                        model: {
                                          value: _vm.management,
                                          callback: function ($$v) {
                                            _vm.management = $$v
                                          },
                                          expression: "management",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.editVisibility || _vm.showInsuranceFeesInput
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.insurance,
                                        ],
                                        "size-class": "col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.insurance-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "insurance",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          label: _vm.$t(
                                            "application-form.insurance-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(1000),
                                        },
                                        model: {
                                          value: _vm.insurance,
                                          callback: function ($$v) {
                                            _vm.insurance = $$v
                                          },
                                          expression: "insurance",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.editVisibility || _vm.showRepairsFeesInput
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.repairs,
                                        ],
                                        "size-class": "col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.repairs-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "repairs",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          label: _vm.$t(
                                            "application-form.repairs-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(1000),
                                        },
                                        model: {
                                          value: _vm.repairs,
                                          callback: function ($$v) {
                                            _vm.repairs = $$v
                                          },
                                          expression: "repairs",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.editVisibility || _vm.showInterestFeesInput
                                ? _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.interest,
                                        ],
                                        "size-class": "col-md-6 col-12",
                                        title: _vm.$t(
                                          "application-form.interest-fees-monthly"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "interest",
                                          placeholder: "0",
                                          "class-name": "dollar",
                                          label: _vm.$t(
                                            "application-form.interest-fees-monthly"
                                          ),
                                          tabindex: _vm.tabIndex(1000),
                                        },
                                        model: {
                                          value: _vm.interest,
                                          callback: function ($$v) {
                                            _vm.interest = $$v
                                          },
                                          expression: "interest",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "existing-mortgages-" + _vm.propertyIndex,
                  staticClass: "card single-card",
                  attrs: { id: "existing-mortgages-" + _vm.propertyIndex },
                },
                [
                  _c("resize-sensor", {
                    attrs: { debounce: 50 },
                    on: {
                      resized: function (el) {
                        return _vm.handleResize(
                          "existing-mortgages-" + _vm.propertyIndex
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "resize-wrapper h-auto" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card-header px-5",
                        attrs: {
                          id: _vm._f("hashId")(
                            _vm.applicantKey +
                              "[other-properties][" +
                              _vm.propertyIndex +
                              "][other-property-existing-mortgages]"
                          ),
                        },
                      },
                      [
                        _c("div", { staticClass: "row align-items-end" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("application-card-header", {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$tc(
                                                  "application-form.existing-mortgage",
                                                  2
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "sub-title",
                                      fn: function () {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.ordinalIndex(
                                                    _vm.arrayIndex
                                                  )
                                                ) +
                                                "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "application-form.property"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.applicantFullNameWithSalutation
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                       - " +
                                                    _vm._s(
                                                      _vm.applicantFullNameWithSalutation
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    _vm.address && _vm.address.line1
                                      ? {
                                          key: "extra",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.address.line1) +
                                                  "\n                  "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        }
                                      : null,
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-body px-5" },
                      [
                        _c(
                          "group-set",
                          {
                            attrs: {
                              "group-name": _vm.$tc(
                                "application-form.existing-mortgage",
                                1
                              ),
                              multi:
                                !_vm.editVisibility &&
                                _vm.otherPropertyExistingMortgages.length < 3,
                              path: _vm.getOtherPropertyExistingMortgagesKey(
                                _vm.propertyIndex,
                                _vm.applicantIndex
                              ),
                              source:
                                _vm.applicant["other-properties"][
                                  "" + _vm.propertyIndex
                                ]["other-property-existing-mortgages"],
                              "start-empty": !_vm.editVisibility,
                              portal: "broker",
                              tabindex: _vm.tabIndex(1100),
                            },
                            on: { duplicate: _vm.handleDuplicate },
                          },
                          _vm._l(
                            _vm.otherPropertyExistingMortgages,
                            function (existingMortgage, mortgageIndex) {
                              return _c(
                                "div",
                                {
                                  key: "existing-mortgage-" + mortgageIndex,
                                  staticClass: "row mb-5",
                                  attrs: { "group-index": mortgageIndex },
                                },
                                [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold mb-4 text-secondary text-lowercase form-title-removable",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.ordinalIndex(mortgageIndex)
                                            ) +
                                            "\n                    " +
                                            _vm._s(
                                              _vm.$tc(
                                                "application-form.existing-mortgage",
                                                1
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                        !_vm.editVisibility
                                          ? _c(
                                              "span",
                                              [
                                                _c("inline-prompt", {
                                                  ref: "prompt",
                                                  refInFor: true,
                                                  staticClass:
                                                    "d-inline-block bold text-gray ml-2",
                                                  attrs: {
                                                    "action-type": "delete",
                                                    "confirmation-text": _vm.$t(
                                                      "application.messages.allDataWillBeLost"
                                                    ),
                                                  },
                                                  on: {
                                                    accept: function ($event) {
                                                      _vm.handleRemove(
                                                        mortgageIndex,
                                                        _vm.getOtherPropertyExistingMortgagesKey(
                                                          _vm.propertyIndex,
                                                          _vm.applicantIndex
                                                        ),
                                                        true
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[mortgage-type]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.mortgage-type"
                                        ),
                                        "container-class": "",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          name: "mortgage-type",
                                          options:
                                            _vm.remainingMortgagesTypeOptions,
                                          tabindex: _vm.tabIndex(1100),
                                        },
                                        model: {
                                          value:
                                            existingMortgage["mortgage-type"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "mortgage-type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['mortgage-type']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[balance-remaining]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.balance-remaining"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "balance-remaining",
                                          placeholder: "0",
                                          "class-name": "dollar fe-num-field",
                                          label: _vm.$t(
                                            "application-form.balance-remaining"
                                          ),
                                          tabindex: _vm.tabIndex(1100),
                                        },
                                        model: {
                                          value:
                                            existingMortgage[
                                              "balance-remaining"
                                            ],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "balance-remaining",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['balance-remaining']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[payment-amount]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.payment-amount"
                                        ),
                                        "container-class": "dollar-prepend",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("text-section", {
                                        attrs: {
                                          name: "payment-amount",
                                          placeholder: "0",
                                          "class-name": "dollar fe-num-field",
                                          label: _vm.$t(
                                            "application-form.payment-amount"
                                          ),
                                          tabindex: _vm.tabIndex(1100),
                                        },
                                        model: {
                                          value:
                                            existingMortgage["payment-amount"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "payment-amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['payment-amount']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[frequency]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.frequency"
                                        ),
                                        "container-class": "",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          name: "frequency",
                                          options: _vm.frequencyOptions,
                                          tabindex: _vm.tabIndex(1100),
                                        },
                                        model: {
                                          value: existingMortgage["frequency"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "frequency",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['frequency']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[maturity-date]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.maturity-date"
                                        ),
                                        "container-class": "",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          name: "maturity-date",
                                          placeholder: "YYYY-MM-DD",
                                          "class-name": "date-format",
                                          tabindex: _vm.tabIndex(1100),
                                          label: _vm.$t(
                                            "application-form.maturity-date"
                                          ),
                                        },
                                        on: { change: _vm.handleSave },
                                        model: {
                                          value:
                                            existingMortgage["maturity-date"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "maturity-date",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['maturity-date']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[rate-type]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.rate-type"
                                        ),
                                        "container-class": "",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          name: "rate-type",
                                          options: _vm.rateTypeOptions,
                                          tabindex: _vm.tabIndex(1100),
                                        },
                                        model: {
                                          value: existingMortgage["rate-type"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "rate-type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['rate-type']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    {
                                      attrs: {
                                        "edit-visibility": _vm.editVisibility,
                                        "visibility-paths": [
                                          _vm.visibilityPaths
                                            .otherPropertyExistingMortgages +
                                            "[term-type]",
                                        ],
                                        "size-class": _vm.isMainApplicantScreen
                                          ? "col-12 col-lg-6"
                                          : "col-lg-3 col-md-4 col-12",
                                        title: _vm.$t(
                                          "application-form.term-type"
                                        ),
                                        "container-class": "",
                                      },
                                      on: {
                                        "toggle-visibility":
                                          _vm.handleVisibility,
                                      },
                                    },
                                    [
                                      _c("select-section", {
                                        attrs: {
                                          name: "term-type",
                                          options: _vm.termTypeOptions,
                                          tabindex: _vm.tabIndex(1100),
                                        },
                                        model: {
                                          value: existingMortgage["term-type"],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              existingMortgage,
                                              "term-type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "existingMortgage['term-type']",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row" },
                                      [
                                        _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .otherPropertyExistingMortgages +
                                                  "[lender]",
                                              ],
                                              "size-class":
                                                _vm.isMainApplicantScreen
                                                  ? "col-12 col-lg-6"
                                                  : "col-lg-3 col-md-4 col-12",
                                              title: _vm.$t(
                                                "application-form.lender"
                                              ),
                                              "container-class": "",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("text-section", {
                                              attrs: {
                                                name: "lender",
                                                "max-length": "80",
                                                tabindex: _vm.tabIndex(1100),
                                                label: _vm.$t(
                                                  "application-form.lender"
                                                ),
                                              },
                                              model: {
                                                value:
                                                  existingMortgage["lender"],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    existingMortgage,
                                                    "lender",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "existingMortgage['lender']",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .otherPropertyExistingMortgages +
                                                  "[payoff]",
                                              ],
                                              "size-class":
                                                _vm.isMainApplicantScreen
                                                  ? "col-12 col-lg-6"
                                                  : "col-lg-3 col-md-4 col-12",
                                              title: _vm.$t(
                                                "application-form.payoff"
                                              ),
                                              "container-class": "",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("select-section", {
                                              attrs: {
                                                name: "payoff",
                                                options: _vm.payoffOptions,
                                                tabindex: _vm.tabIndex(1100),
                                              },
                                              model: {
                                                value:
                                                  existingMortgage["payoff"],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    existingMortgage,
                                                    "payoff",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "existingMortgage['payoff']",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .otherPropertyExistingMortgages +
                                                  "[loan-type]",
                                              ],
                                              "size-class":
                                                _vm.isMainApplicantScreen
                                                  ? "col-12 col-lg-6"
                                                  : "col-lg-3 col-md-4 col-12",
                                              title: _vm.$t(
                                                "application-form.loan-type"
                                              ),
                                              "container-class": "",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("select-section", {
                                              attrs: {
                                                name: "loan-type",
                                                options: _vm.loanTypeOptions,
                                                tabindex: _vm.tabIndex(1100),
                                              },
                                              model: {
                                                value:
                                                  existingMortgage["loan-type"],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    existingMortgage,
                                                    "loan-type",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "existingMortgage['loan-type']",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "field",
                                          {
                                            staticClass: "mb-md-0 mb-4",
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .otherPropertyExistingMortgages +
                                                  "[interest-rate]",
                                              ],
                                              "size-class":
                                                _vm.isMainApplicantScreen
                                                  ? "col-12 col-lg-6"
                                                  : "col-lg-3 col-md-4 col-12",
                                              "side-label-size": "col-auto",
                                              "side-label": true,
                                              title: _vm.$t(
                                                "application-form.interest-rate"
                                              ),
                                              "container-class":
                                                "perc-append w-60",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("text-section", {
                                              attrs: {
                                                name: "interest-rate",
                                                placeholder: "0.00",
                                                "class-name": "rate",
                                                tabindex: _vm.tabIndex(1100),
                                                label: _vm.$t(
                                                  "application-form.interest-rate"
                                                ),
                                              },
                                              model: {
                                                value:
                                                  existingMortgage[
                                                    "interest-rate"
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    existingMortgage,
                                                    "interest-rate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "existingMortgage['interest-rate']",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "field",
                                          {
                                            attrs: {
                                              "edit-visibility":
                                                _vm.editVisibility,
                                              "visibility-paths": [
                                                _vm.visibilityPaths
                                                  .otherPropertyExistingMortgages +
                                                  "[orig-amount]",
                                              ],
                                              "size-class":
                                                _vm.isMainApplicantScreen
                                                  ? "col-12 col-lg-6"
                                                  : "col-lg-3 col-md-4 col-12",
                                              "long-title": true,
                                              title: _vm.$t(
                                                "application-form.original-mortgage-amount"
                                              ),
                                              "container-class":
                                                "dollar-prepend",
                                            },
                                            on: {
                                              "toggle-visibility":
                                                _vm.handleVisibility,
                                            },
                                          },
                                          [
                                            _c("text-section", {
                                              attrs: {
                                                name: "orig-amount",
                                                placeholder: "0",
                                                "class-name":
                                                  "dollar fe-num-field",
                                                tabindex: _vm.tabIndex(1100),
                                                label: _vm.$t(
                                                  "application-form.original-mortgage-amount"
                                                ),
                                              },
                                              model: {
                                                value:
                                                  existingMortgage[
                                                    "orig-amount"
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    existingMortgage,
                                                    "orig-amount",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "existingMortgage['orig-amount']",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }